import { SCENE_STATES } from "../data/sceneStates.js";

const ALLOWED_TRANSITIONS = {
  [SCENE_STATES.BOOT]: [SCENE_STATES.INTRO, SCENE_STATES.LEGAL],
  [SCENE_STATES.INTRO]: [
    SCENE_STATES.ABOUT,
    SCENE_STATES.PROJECTS,
    SCENE_STATES.SKILLS,
    SCENE_STATES.CONTACT,
    SCENE_STATES.LEGAL
  ],
  [SCENE_STATES.ABOUT]: [
    SCENE_STATES.INTRO,
    SCENE_STATES.PROJECTS,
    SCENE_STATES.SKILLS,
    SCENE_STATES.CONTACT,
    SCENE_STATES.LEGAL
  ],
  [SCENE_STATES.PROJECTS]: [
    SCENE_STATES.INTRO,
    SCENE_STATES.ABOUT,
    SCENE_STATES.SKILLS,
    SCENE_STATES.CONTACT,
    SCENE_STATES.LEGAL,
    SCENE_STATES.PROJECT_DETAIL
  ],
  [SCENE_STATES.PROJECT_DETAIL]: [SCENE_STATES.PROJECTS, SCENE_STATES.CONTACT, SCENE_STATES.LEGAL],
  [SCENE_STATES.SKILLS]: [
    SCENE_STATES.INTRO,
    SCENE_STATES.ABOUT,
    SCENE_STATES.PROJECTS,
    SCENE_STATES.CONTACT,
    SCENE_STATES.LEGAL
  ],
  [SCENE_STATES.CONTACT]: [
    SCENE_STATES.INTRO,
    SCENE_STATES.PROJECTS,
    SCENE_STATES.SKILLS,
    SCENE_STATES.LEGAL
  ],
  [SCENE_STATES.LEGAL]: [
    SCENE_STATES.INTRO,
    SCENE_STATES.ABOUT,
    SCENE_STATES.PROJECTS,
    SCENE_STATES.SKILLS,
    SCENE_STATES.CONTACT
  ],
  [SCENE_STATES.TRANSITIONING]: []
};

export class StateMachine {
  constructor(initialState = SCENE_STATES.BOOT) {
    this.currentState = initialState;
    this.previousState = null;
    this.pendingState = null;
    this.pendingPayload = null;
    this.events = new EventTarget();
  }

  on(eventName, listener) {
    this.events.addEventListener(eventName, listener);
  }

  off(eventName, listener) {
    this.events.removeEventListener(eventName, listener);
  }

  canTransition(toState) {
    if (!(toState in ALLOWED_TRANSITIONS)) {
      return false;
    }

    if (this.currentState === SCENE_STATES.TRANSITIONING) {
      return false;
    }

    if (this.currentState === toState) {
      return false;
    }

    return ALLOWED_TRANSITIONS[this.currentState].includes(toState);
  }

  transition(toState, payload = {}) {
    if (!this.canTransition(toState)) {
      return false;
    }

    this.previousState = this.currentState;
    this.pendingState = toState;
    this.pendingPayload = payload;
    this.currentState = SCENE_STATES.TRANSITIONING;

    this.events.dispatchEvent(
      new CustomEvent("transitionstart", {
        detail: {
          from: this.previousState,
          to: toState,
          payload
        }
      })
    );

    return true;
  }

  commitTransition() {
    if (this.currentState !== SCENE_STATES.TRANSITIONING || !this.pendingState) {
      return false;
    }

    const nextState = this.pendingState;
    const payload = this.pendingPayload;
    this.currentState = nextState;
    this.pendingState = null;
    this.pendingPayload = null;

    this.events.dispatchEvent(
      new CustomEvent("statechange", {
        detail: {
          state: this.currentState,
          previous: this.previousState,
          payload
        }
      })
    );

    return true;
  }

  forceSet(state, payload = {}) {
    this.previousState = this.currentState;
    this.currentState = state;
    this.pendingState = null;
    this.pendingPayload = null;

    this.events.dispatchEvent(
      new CustomEvent("statechange", {
        detail: {
          state: this.currentState,
          previous: this.previousState,
          payload
        }
      })
    );
  }
}
